<template lang="pug">
	section.section.main-section
		.container
			title-comp(:name="$t('title.warnings')")
			hourglass(v-if="loading")
			.html-page-container(v-html="content")

</template>

<script>
import HourglassComponent from '../components/HourglassComponent.vue'
import TitleComponent from '../components/TitleComponent.vue'
import { ChevronLeftIcon } from 'vue-feather-icons'

export default {
	components: {
		Hourglass: HourglassComponent,
		TitleComp: TitleComponent,
		ChevronLeftIcon
	},
	computed: {
		content() {
			return this.$store.state.general.warnings
		},
		loading() {
			return this.$store.state.general.loading
		}
	},
	mounted() {
		this.$meta().setOptions({ title: this.$t("title.warnings") + ' | ' + this.$t("title.home") })
		if (!this.content) {
			this.$store.dispatch('general/getWarningsPage', { locale: this.$t('locale.lang') })
		}
	},
	watch: {
		content() {
			if (this.content === '') {
				this.$store.dispatch('general/getWarningsPage', { locale: this.$t('locale.lang') })
			}
		}
	}
}
</script>
